

















import { Component, Vue } from "vue-property-decorator";
import { createAppUser } from "@/graphql/mutation/createAppUser";

import CButton from "@/basics/buttons/CButton.vue";
import LabelInputText from "@/components/inputs/LabelInputText.vue";
import LabelInputDate from "@/components/inputs/LabelInputDate.vue";
import NoteBox from "@/basics/boxes/NoteBox.vue";

@Component({
  components: {
    CButton,
    LabelInputText,
    LabelInputDate,
    NoteBox    
  }
})
export default class AppAccountsNew extends Vue {
  name = "";
  dates = { start: new Date(), end: new Date(Date.now() + 24 * 3_600_000) };

  get groupId(): string {
    return this.$route.params.groupId;
  }

  async click() {
    const name = this.name.trim();
    const { start, end } = this.dates;

    // バリデーション
    if (!name) {
      alert("設置アプリアカウント名を入力してください");
      return;
    }

    if (end <= start || end < new Date()) {
      alert("有効期限を確認してください");
      return;
    }

    try {
      await createAppUser(this.$apollo, {
        name,
        groupId: this.groupId,
        start: start.getTime(),
        end: end.getTime()
      });
      this.$router.push({ name: "app-accounts-list" });
    } catch (e) {
      console.error(e);
      alert("設置アプリアカウント作成に失敗しました");
    }
  }
}
